import Styled from "styled-components";

export const Container = Styled.div`
  padding: 2rem 0 0 0;
`;

export const Content = Styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  margin: 0 auto;
  border-radius: 1.25rem;
  border: 1px solid #373737;
  overflow: hidden;
  background: ${(props) => props.theme.colors.black};
  overflow: hidden;

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 3rem);
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
  }
`;

export const Message = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
  color: white;
  
  ${(props) => props.theme.breakpoints.up("large")} {
    padding: 5.625rem;
    gap: 2rem;
  }
`;

export const Link = Styled.a`
  text-decoration: none;
`;
